import {useWeb3React} from '@web3-react/core';

const WalletInfo = () => {
  const {active, chainId, account, error} = useWeb3React();
  return (

  <div className="wallet-info">
    <p>Wallet Information</p>
    <p>Active: {active.toString()}</p>
    {active && (
    <div>
      <p>Account: {account}</p>
      <p>ChainId: {chainId}</p>
    </div>
    )}
    {error && <p className="text-error">error: {error.message}</p>}
  </div>
  );
};

export default WalletInfo;
